import React from 'react'
import AboutUs from '../components/about/AboutUs';
import WhyChooseUs from '../components/about/WhyChooseUs';
import MaterialsSection from '../components/about/MaterialsSection';
import OccasionsSection from '../components/about/OccasionsSection';
import CustomizeCTA from '../components/about/CustomizeCTA';

const About = () => {
    return (
        <div>
            <AboutUs />
            <WhyChooseUs />
            <MaterialsSection />
            <OccasionsSection />
            <CustomizeCTA />
        </div>
    )
}

export default About